import React from "react";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

const AddressError: React.FC = () => {
  return (
    <div
      id="address-error"
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid red",
        padding: "10px",
        backgroundColor: "#f8d7da",
        color: "#721c24",
      }}
    >
      <span id="address-error-icon">
        <ReportProblemIcon color="error" />
      </span>
      <span>
        <b style={{ color: "black" }}>
          We identified an issue with your delivery address.
        </b>{" "}
        To ensure your package arrives safely, please double-check your
        information and make any necessary correction
      </span>
    </div>
  );
};

export default AddressError;
